import { api, endpoints } from "api/api";
import { BaseApiPaging } from "api/types";
import { AxiosPromise } from "axios";
import {
  CreateScheduledMessageRequest,
  CreateScheduledMessageResponse,
  UpdateScheduledMessageRequest,
  ScheduledMessageApi,
  ScheduledMessageRecipientApi,
} from "api/types/ScheduledMessage";

const create = (data: CreateScheduledMessageRequest): AxiosPromise<CreateScheduledMessageResponse> => {
  return api.post<CreateScheduledMessageResponse>(endpoints.SCHEDULED_MESSAGES.CREATE(), data);
};

const update = (id: number, data: UpdateScheduledMessageRequest): AxiosPromise => {
  return api.put(endpoints.SCHEDULED_MESSAGES.UPDATE(id), data);
};

const fetch = (
  skip: number,
  take: number,
  searchPhrase: string,
  filter: string = "",
  orderBy: string = "",
): AxiosPromise<BaseApiPaging<ScheduledMessageApi>> => {
  return api.get<BaseApiPaging<ScheduledMessageApi>>(
    endpoints.SCHEDULED_MESSAGES.GET(skip, take, searchPhrase, filter, orderBy),
  );
};

const fetchById = (id: number): AxiosPromise<ScheduledMessageApi> => {
  return api.get<ScheduledMessageApi>(endpoints.SCHEDULED_MESSAGES.GET_BY_ID(id));
};

const fetchRecipients = (id: number): AxiosPromise<ScheduledMessageRecipientApi[]> => {
  return api.get<ScheduledMessageRecipientApi[]>(endpoints.SCHEDULED_MESSAGES.GET_RECIPIENTS(id));
};

const schedule = (id: number, deliveryTime: string): AxiosPromise => {
  return api.post(endpoints.SCHEDULED_MESSAGES.SCHEDULE(id), { deliveryTime });
};

const sendImmediately = (id: number): AxiosPromise => {
  return api.post(endpoints.SCHEDULED_MESSAGES.SEND(id));
};

const cancel = (id: number): AxiosPromise => {
  return api.post(endpoints.SCHEDULED_MESSAGES.CANCEL(id));
};

const deleteMessage = (id: number): Promise<void> => {
  return api.delete(endpoints.SCHEDULED_MESSAGES.DELETE(id));
};

export const scheduledMessagesApi = {
  create,
  fetch,
  fetchById,
  fetchRecipients,
  update,
  schedule,
  sendImmediately,
  cancel,
  delete: deleteMessage,
};

// Re-export types for convenience
export type {
  CreateScheduledMessageRequest,
  CreateScheduledMessageResponse,
  UpdateScheduledMessageRequest,
  ScheduledMessageApi,
  ScheduledMessageRecipientApi,
  MessageRecipientRequest,
} from "api/types/ScheduledMessage";
